export class CourtInfoLog {
    courtModelId!: string;
    submissionId!: string;
    userId!: string;
    organizationId!: string;
    enteredByTitle!: string;
    enteredByName!: string;
    dateModified!: string;
    isBondConditions!: string;
}